import type { NoDataSource } from '@pn/core/domain/workspace';
import type { IDataProvider } from '@pn/core/services/data/ports';

export const noDataProvider: IDataProvider<NoDataSource> = () => ({
  getDataMapping: async () => ({}),
  getDataByQuery: async () => ({ data: [], totalCount: 0 }),
  streamDataByQuery: async () => ({ data: [], totalCount: 0 }),
  getItemById: async () => undefined,
});
